import React, {useState} from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import {trySetTimeout} from "../../hooks/trySetTiemout";
import {useTranslation} from "react-i18next";

function GroupGamesListRowDetailsPlayer(props) {
    const [linkCopied, setLinkCopied] = useState(false)
    const { t } = useTranslation('translation', { keyPrefix: 'gamesListPage' });

    function copyUrlToClipboard(playerId) {
        navigator.clipboard.writeText(window.location.host + `/groupgame/${props.gameId}?player=${playerId}`);
        setLinkCopied(true)
        trySetTimeout(() => {
            setLinkCopied(false)
        }, 3000)
    }

    function renderTooltip(text) {
        return (<Tooltip id="button-tooltip">
            {text}
        </Tooltip>)
    }

    function openGameCommentsPage() {
        window.open(`/group_game_comments/${props.gameId}/${props.player.id}`, "_blank")
    }

    return (
        <div>
            <div style={{
                display: "flex",
                flexDirection: "rows",
                padding: "6px",
                gap: "12px"
            }}>
                <div><b>{t('player')}:</b> {props.player.name.trim()}</div>
                <OverlayTrigger
                    placement="bottom"
                    delay={{show: 50, hide: 400}}
                    overlay={renderTooltip(t('copyPlayerLink'))}
                >
                    <ContentCopyIcon sx={linkCopied ? {color: '#64dd17'} : {color: 'var(--mentor-cabinet-copy_button)'}}
                                     onClick={() => copyUrlToClipboard(props.player.id)}></ContentCopyIcon>
                </OverlayTrigger>
                <div>
                    <OverlayTrigger
                        placement="bottom"
                        delay={{show: 50, hide: 400}}
                        overlay={renderTooltip(t('allGameComments'))}
                    >
                        <DescriptionOutlinedIcon style={{fontSize: "x-large"}}
                                                 onClick={openGameCommentsPage}></DescriptionOutlinedIcon>
                    </OverlayTrigger>
                </div>
            </div>
        </div>
    )
}

export default GroupGamesListRowDetailsPlayer;